import type { LogoProps } from '../logo.types';
import bgdarkgreenLarge from '../../../assets/logos/logo-rd-tagline-bgdarkgreen-large.svg';
import bgdarkgreenHuge from '../../../assets/logos/logo-rd-tagline-bgdarkgreen-huge.svg';
import bgdarkgreenEnormous from '../../../assets/logos/logo-rd-tagline-bgdarkgreen-enormous.svg';

const sizeToImage = {
  large: bgdarkgreenLarge,
  huge: bgdarkgreenHuge,
  enormous: bgdarkgreenEnormous,
};

const TITLE = "RdSaude Tagline BgDarkGreen Logo"

const RdSaudeTaglineBgDarkGreen = ({ size, className }: LogoProps) => {
  return (
    <img
      title={TITLE}
      role='img'
      aria-labelledby={TITLE}
      src={sizeToImage[size ?? "large"]}
      alt={TITLE}
      className={className}
    />
  );
};

export default RdSaudeTaglineBgDarkGreen; 